import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import './Header.css';

const Header = () => {
  const { user, logout, roles } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);

  const isAdmin = roles.includes('admin');
  const isConsultor = roles.includes('consultor');

  return (
    <header className="app-header">
      <div className="header-content">
        <NavLink to="/home" className="logo-link">
          <img src="/logoo.png" alt="MatrixGen Logo" className="header-logo" />
        </NavLink>

        <nav className={`main-nav ${menuOpen ? 'open' : ''}`}>
          <NavLink to="/home">Inicio</NavLink>
          <NavLink to="/projects">Proyectos</NavLink>
          {(isConsultor || isAdmin) && (
            <>
              <NavLink to="/templates">Plantillas</NavLink>
              <NavLink to="/master-matrix">Matriz Maestra</NavLink>
            </>
          )}
          {isAdmin && <NavLink to="/admin">Administración</NavLink>}
        </nav>

        <div className="header-actions">
          {user && (
            <div className="profile-menu">
              <button
                onClick={() => setProfileOpen(!profileOpen)}
                className="profile-button"
              >
                {user.picture ? (
                  <img src={user.picture} alt="Profile" className="profile-avatar" />
                ) : (
                  user.name?.charAt(0) || user.email.charAt(0)
                )}
              </button>
              {profileOpen && (
                <div className="profile-dropdown">
                  <div className="profile-info">
                    <strong>{user.name || user.email}</strong>
                    <span className="user-roles">{roles.join(', ')}</span>
                  </div>
                  <button onClick={logout}>Cerrar Sesión</button>
                </div>
              )}
            </div>
          )}
          <button
            className="hamburger"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            &#9776;
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header; 